// extracted by mini-css-extract-plugin
module.exports = {"content":"tooltip_content__KKYQd","hover":"tooltip_hover__Tpxzz","click":"tooltip_click__3zT8B","arrow":"tooltip_arrow__2C29K","tooltip":"tooltip_tooltip__1M5t3"};